<template>
  <div class="pay-center-reminder">
    <div class="pay-center-reminder-title">温馨提示</div>
    <div class="pay-center-reminder-content"
         v-html="content"
    ></div>
  </div>
</template>

<script>
  export default {
    name: 'PayCenterReminder',
    props: {
      content: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-center-reminder {
    margin-top: @size-small;
    padding: @size-base;
    color: @color-text-lighter;
    font-size: @font-size-small;
    background-color: @color-white;
    text-align: center;
  }

  @reminder-title-padding: 46px;
  .pay-center-reminder-title {
    display: inline-block;
    text-align: center;
    font-size: @font-size-base;
    margin-bottom: @size-extra-small;
    position: relative;
    &::before, &::after {
      content: '';
      position: absolute;
      display: block;
      width: 26px;
      height: 2px;
      top: 50%;
      transform: translateY(-50%);
      background-color: @color-text-lighter;
    }
    &::before {
      left: -@reminder-title-padding;
    }
    &::after {
      right: -@reminder-title-padding;
    }
  }

  .pay-center-reminder-content {
    line-height: 1.4;
    text-align: left;
  }
</style>
